import React, { useEffect, useRef, useState } from "react";

const SANDBOX_CHECKOUT_SRC =
    "https://static-content-qas.vnforapps.com/env/sandbox/js/checkout.js";

export const NiubizManualTester: React.FC = () => {
    const BASE_URL = process.env.REACT_APP_PROXY;
    // Cambia estos valores por los que generas realmente desde tu back
    const [sessionKey, setSessionKey] = useState(
        "f06aca5e2f50966caf61e518e8169f50398c7471a7990c064a6c5f2160f06b57"
    );
    const [merchantId, setMerchantId] = useState("456879852");
    const [purchaseNumber, setPurchaseNumber] = useState("2020100901");
    const [amount, setAmount] = useState("10");
    const [expirationMinutes, setExpirationMinutes] = useState(20);

    const scriptRef = useRef<HTMLScriptElement | null>(null);

    const hardClean = () => {
        if (scriptRef.current) {
            try {
                scriptRef.current.remove();
            } catch {}
            scriptRef.current = null;
        }
        const leftovers = document.querySelectorAll(
            'script[src*="checkout.js"], iframe[src*="niubiz"], iframe[src*="vnforapps"], .niubiz-checkout, .btn-pay, .btn-niubiz'
        );
        leftovers.forEach((n) => n.parentElement?.removeChild(n));
    };

    const loadButton = () => {
        hardClean();

        if (
            !sessionKey.trim() ||
            !merchantId.trim() ||
            !purchaseNumber.trim() ||
            !amount.trim()
        ) {
            alert("Completa sessionKey, merchantId, purchaseNumber y amount.");
            return;
        }

        const form = document.getElementById("niubiz-form");
        if (!form) {
            alert("No se encontró el formulario con id='niubiz-form'.");
            return;
        }

        const s = document.createElement("script");
        s.type = "text/javascript";
        s.src = SANDBOX_CHECKOUT_SRC;

        s.setAttribute("data-sessiontoken", sessionKey.trim());
        s.setAttribute("data-channel", "web");
        s.setAttribute("data-merchantid", merchantId.trim());
        s.setAttribute("data-purchasenumber", purchaseNumber.trim());
        s.setAttribute("data-amount", amount.trim());
        s.setAttribute("data-expirationminutes", String(expirationMinutes));

        // Opcionales
        s.setAttribute("data-timeouturl", "about:blank");
        s.setAttribute(
            "data-merchantlogo",
            "https://via.placeholder.com/187x40.png"
        );
        s.setAttribute("data-formbuttoncolor", "#000000");
        s.setAttribute("data-buttonsize", "DEFAULT");
        s.setAttribute("data-buttoncolor", "NAVY");

        form.appendChild(s);
        scriptRef.current = s;
    };

    useEffect(() => () => hardClean(), []);

    return (
        <div className="max-w-xl p-6 mx-auto space-y-4">
            <h2 className="text-xl font-semibold">
                🧩 Niubiz – Prueba de botón de pago (Sandbox)
            </h2>

            <div className="grid gap-3">
                <label className="text-sm">
                    sessionKey
                    <textarea
                        className="w-full p-2 text-xs border rounded"
                        rows={3}
                        value={sessionKey}
                        onChange={(e) => setSessionKey(e.target.value)}
                    />
                </label>

                <div className="grid grid-cols-2 gap-3">
                    <label className="text-sm">
                        merchantId
                        <input
                            className="w-full p-2 border rounded"
                            value={merchantId}
                            onChange={(e) => setMerchantId(e.target.value)}
                        />
                    </label>
                    <label className="text-sm">
                        purchaseNumber
                        <input
                            className="w-full p-2 border rounded"
                            value={purchaseNumber}
                            onChange={(e) => setPurchaseNumber(e.target.value)}
                        />
                    </label>
                </div>

                <div className="grid grid-cols-2 gap-3">
                    <label className="text-sm">
                        amount (S/)
                        <input
                            className="w-full p-2 border rounded"
                            value={amount}
                            onChange={(e) => setAmount(e.target.value)}
                        />
                    </label>
                    <label className="text-sm">
                        expirationMinutes
                        <input
                            type="number"
                            className="w-full p-2 border rounded"
                            value={expirationMinutes}
                            onChange={(e) =>
                                setExpirationMinutes(Number(e.target.value))
                            }
                        />
                    </label>
                </div>

                <button
                    onClick={loadButton}
                    className="px-4 py-2 text-white transition bg-blue-600 rounded hover:bg-blue-700">
                    Cargar botón de pago
                </button>
            </div>

            <form
                id="niubiz-form"
                action={`${BASE_URL}/niubiz/transaction`}
                method="post"
                target="niubiz_sink"
                className="mt-4">
                <input type="hidden" name="amount" value={amount} />
                <input
                    type="hidden"
                    name="purchaseNumber"
                    value={purchaseNumber}
                />
            </form>
            <iframe name="niubiz_sink" style={{ display: "none" }} />
        </div>
    );
};

export default NiubizManualTester;
